module.exports = __webpack_public_path__ + "static/media/GM2-2.70264a38.jpg";